import { render } from "./PhoneForm.vue?vue&type=template&id=720ede9c&scoped=true&ts=true"
import script from "./PhoneForm.vue?vue&type=script&lang=ts"
export * from "./PhoneForm.vue?vue&type=script&lang=ts"

import "./PhoneForm.vue?vue&type=style&index=0&id=720ede9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720ede9c"]])

export default __exports__